import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import {
    ReactNode, useContext, useEffect, useId,
} from 'react';

import TabContext from './TabContext';

interface Props {
    children?: ReactNode;
    onClick?: () => void;
    selected?: boolean;
}

function TabItem({ children, onClick, selected }:Props) {
    const { variant, setCurrentId } = useContext(TabContext);
    const id = useId();
    useEffect(() => {
        if (selected) {
            setCurrentId(id);
        }
    }, [selected, id, setCurrentId]);
    if (variant === 'transparent') {
        return (
            <TransparentTabItem isSelected={!!selected}
                id={id}
                aria-label='tab'
                data-selected={!!selected}
                onClick={onClick} >
                <Text size='lg'
                    fontWeight={selected ? 'bold' : 'regular'} >
                    {children}
                </Text>
            </TransparentTabItem>
        );
    }
    return (
        <SolidTabItem onClick={onClick}
            id={id}
            aria-label='tab'
            isSelected={!!selected}
            data-selected={!!selected}>
            <Text size='lg' color={selected ? colors.gray8 : colors.gray5}
                fontWeight='bold'>
                {children}
            </Text>
        </SolidTabItem>
    );
}

const TransparentTabItem = styled.div<{isSelected: boolean}>`
    flex: 1;
    padding: 19px 0;
    //border-bottom: ${(props) => (props.isSelected ? '2px solid var(--color-primary)' : 'none')};
    display: flex;
    justify-content: center;
    //margin-bottom: -2px;
`;

const SolidTabItem = styled.div<{isSelected: boolean}>`
    padding: 10px 8px;
`;

export default TabItem;
